const Changelog = () => {
  const changelogEntries = [
    {
      date: "July 29, 2025",
      sections: [
        {
          title: "AI as a Service Launch",
          content: "Our AI as a Service feature is now available. Users can access ready-to-use endpoints that are pre-deployed and ready for immediate integration. We're launching with the Typhoon-OCR model endpoint, priced at approximately $0.03 (or 1 THB) per request.\n\nIf you're interested in exploring this service or need assistance with integration, feel free to reach out at 087-660-4840 or email namfon.kha@float16.cloud."
        }
      ]
    },
    {
      date: "May 15, 2025",
      sections: [
        {
          title: "Billing Feature Launch",
          content: "Our Service billing feature is now available. Users can access services up to $100 per month with usage summaries provided on the 1st of each following month. For limit increases beyond $100, please contact us at 087-660-4840 or email namfon.kha@float16.cloud."
        }
      ]
    },
    {
      date: "March 10, 2025",
      sections: [
        {
          title: "Serverless GPU Service",
          content: "Our Serverless GPU service is now available, but we are still working on the billing feature. At this stage, you can explore the service with a budget limit of $2. \n\nIf you're interested in trying it out, feel free to reach out at 087-660-4840 or email namfon.kha@float16.cloud. Please note that the service is still in the testing phase, so performance may vary."
        },
        {
          title: "LLM as a Service & One-Click Deploy Update",
          content: "We are currently enhancing both LLM as a Service and One-Click Deploy in Production, so they are temporarily unavailable. Our team is working hard to bring them back as soon as possible. Thank you for your patience!"
        }
      ]
    }
  ];

  return (
    <>
      <div className="text-center">
        <h1 className="mb-6 text-2xl font-semibold">Changelog</h1>
        <p className="mx-auto max-w-lg">
          Stay updated with all the latest improvements and new features
          released on our platform. Never miss important updates and fixes.
        </p>
      </div>
      <div className="mx-auto mt-12 max-w-3xl space-y-10 border-l border-dashed border-border pl-6">
        {changelogEntries.map((entry, index) => (
          <div key={index}>
            <p className="relative font-mono text-sm text-muted-foreground">
              <time className="absolute -left-6 top-1 h-3 w-3 -translate-x-1/2 rounded-full bg-success"></time>
              {entry.date}
            </p>
            
            {entry.sections.map((section, sectionIndex) => (
              <div key={sectionIndex}>
                <h2 className="mb-2 mt-4 text-xl font-semibold">
                  {section.title}
                </h2>
                <p className="prose dark:prose-invert text-primary/80 whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Changelog;
